import routerTypes from './route-types'

const PollingLogListView = r => require.ensure([], () => r(require('./PollingLogListView.vue')), 'pollingloglist-chunk')

export default [
  {
    path: routerTypes.PollingLogListView.path,
    name: routerTypes.PollingLogListView.name,
    component: PollingLogListView,
    meta: {
      route: 'listing',
      title: 'Polling Logs'
    }
   }
]